import { FormSectionHandler } from '../entity.handler';
import { AssetTagResponse, AssetTagUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    serialNumber?: string;
    assetTagType?: IdName;
    mode?: string;
}

export class AssetTagDetailsSectionHandler implements FormSectionHandler<AssetTagResponse, EditorValues> {

    type = 'form';
    icon = ICONS.assettag;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService
    ) {
    }

    private properties = ['name', 'serialNumber', 'assetTagType', 'mode'];
    private modes = ['movable', 'fixed', 'stock'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSETTAG.DETAILS.${key}`, values);
    }

    applyUpdate(entity: AssetTagResponse, payload: AssetTagUpdateRequest): Promise<AssetTagResponse> {
        return this.admin.applyUpdate(api => api.entities.updateAssetTag(entity.id, payload));
    }

    mapEntityToEditor(entity: AssetTagResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: AssetTagUpdateRequest, values: EditorValues): Promise<AssetTagUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: AssetTagResponse): Promise<FormBuilderField[]> {

        return this.grouping.getAssetTagTypes(this.ownerId).then(assetTagTypes => {
       
            return [
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
                TextField('serialNumber', this.translate('FIELDS.SERIAL_NUMBER'), true, 1, 255),
                ComboField('assetTagType', this.translate('FIELDS.ASSET_TAG_TYPE'), true, EntityUtils.treeToComboValues(assetTagTypes), IdNameComboValueHandlers),
                ComboField('mode', this.translate('FIELDS.MODE'), true, this.modes.map(x => ({ key: x, value: this.admin.translate(`EDITORS.ASSETTAG.MODES.${x.toUpperCase()}`) })).sort((a, b) => a.value.localeCompare(b.value))),

            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, ['assetTagType', 'mode'], fields));
    }

}
